import User from '../models/User';
import Payment from '../models/Payment';
import FeatureDetails from '../models/features/FeatureDetails';

export default class LandingpageController {
	/*@ngInject;*/
	constructor($scope, $timeout, $interval, $http, $location, $route, $routeParams, $sce, $window) {
	    var content = window.translations,
            user = new User(),
            landing_page_images = window.landing_page_images,
            scrollTime = 0.3,
            scrollDistance = 130,
			brandCode = window.brand_code,
			brandProducts = window.brand_products,
            brandColorType = window.brand_color_type;

		//Scrolling window smoothness
		$($window).on("mousewheel DOMMouseScroll", function(event){
			event.preventDefault();

			var delta = event.originalEvent.wheelDelta/120 || -event.originalEvent.detail/3;
			var scrollTop = $($window).scrollTop();
			var finalScroll = scrollTop - parseInt(delta*scrollDistance);

			TweenMax.to($window, scrollTime, {
				scrollTo : { y: finalScroll, autoKill:true },
					ease: Power1.easeOut,
					autoKill: true,
					overwrite: 5
			});
		});

		var feature_details = new FeatureDetails($sce, content, brandCode, brandColorType, landing_page_images);

		$scope.features_col = 'col-md-3';
        $scope.how_it_works = {};

        if (Object.keys(window.landing_page_features).length != Object.keys(feature_details).length) {
            for (var index in window.landing_page_features) {
                for (let i in feature_details) {
                    if (i == window.landing_page_features[index]) {
                        $scope.how_it_works[i] = feature_details[i];
                    }
                }
            }
        } else {
            $scope.how_it_works = feature_details;
        }

        var count = 0;

        for (let i  in $scope.how_it_works) {
            $scope.how_it_works[i].description.position = 'right';

            if (count % 2 == 1) {
                $scope.how_it_works[i].description.position = 'left';
                $scope.how_it_works[i].description.background = '';
            }

            count++;
        }

        if (Object.keys($scope.how_it_works).length == 3) {
            $scope.features_col = 'col-md-4';
        }

        if (Object.keys($scope.how_it_works).length == 2) {
            $scope.features_col = 'col-md-6';
        }

        var screenshotImages = [];

        if (brandProducts.includes('DPS')) {
            screenshotImages.push({
                file		: '/images/generali/screen/'+ landing_page_images.carousel.carousel_iphone,
                alt 		: ''
            });
		}

        screenshotImages.push(
            {
                file		: '/images/generali/screen/'+ landing_page_images.carousel.carousel_macbook,
                alt 		: ''
            },
            {
                file		: '/images/generali/screen/'+ landing_page_images.carousel.carousel_ipad,
                alt 		: ''
            },
            {
                file		: '/images/generali/screen/'+ landing_page_images.carousel.carousel_iphone_db,
                alt 		: ''
            }
		);


		$scope.screenshots = {
			type 	: 'coverflow',
			delay 	: 5000,
			images 	: screenshotImages
		};
		$scope.pricings = {
			type			: content['our-plan-monthly-text'],
			prices 			: {
				monthly : {
					type 		: content['our-plan-monthly-text'],
					type_name 	: 'monthly',
					interval 	: 'month',
					price 		: [8,99],
					delay 		: '.1s'
				},
				annually : {
					type 		: content['our-plan-annually-text'],
					type_name	: 'annually',
					interval 	: 'annual',
					price 		: [89,99],
					delay 		: '.2s'
				}
			},
			delay 			: '.1',
			descriptions 	: [
				{icon: 'flaticon-dashboard', text: 'Dashboard to access reports/alerts/software'},
				{icon: 'flaticon-time', text: 'Real-time status of your digital footprint'},
				{icon: 'flaticon-warning', text: 'Real-time alerts of data found on internet or dark web'},
				{icon: 'flaticon-shield-4', text: 'Software protecting everything you enter online'},
				{icon: 'flaticon-telemarketer', text: '24/7 ID Assistance'}
			]
		};
		$scope.price_type = content['our-plan-monthly-text'].toLowerCase();

		$scope.toggleValue = true;
		$scope.features_btn_active = false;
		$scope.payment = {
			active 		: false,
			curr_step	: 1,
			form		: []
		};

		user.getUserDetails().then((value)=> {
			//console.log(value);
		});

		$('#landingSideMenu').on('show.bs.offcanvas', function() {
			$('body .main_container').bind('touchmove', function(e){
				e.preventDefault();
			});

			$('.main_container').click(function(){
				$('#landingSideMenu').offcanvas('hide');
			});

			$('body.dialogShowing').css('overflow', 'hidden');
		});

		$('#landingSideMenu').on('hide.bs.offcanvas', function() {
			$('body .main_container').unbind('touchmove');
			$('.main_container').unbind('click');
		});

        $('.thumbVideo .video .bg').css({
			height 	: $('.thumbVideo .video').css('height')
		});

		$('.thumbVideo .video').on('mouseover', function(){
			var playButton = $(this).find('svg');

            playButton.animate({
				opacity: 0.5
			}, 100);
		});

        $('.thumbVideo .video').on('mouseout', function(){
            var playButton = $(this).find('svg');

            playButton.animate({
                opacity: 1
            }, 100);
        });

		$(window).on('load', function() {
			$('#loader').fadeOut('fast', function() {
				$(this).remove();
			});
		});

		$(window).scroll(function(event){
			var scroll_pos	= $(window).scrollTop(),
				first_pos	= $('#id_monitoring').offset().top,
				last_pos	= $('#id_assistance').offset().top;

			if ((scroll_pos < first_pos - 100) || (scroll_pos > last_pos + 300)) {
				$scope.$apply(()=>{
					$scope.features_btn_active = false;
				});
			}
		});

		$timeout(function () {
			var numbers = [],
				titles_numbers = [];

            $('.feature-block h4').each(function() {
                titles_numbers.push($(this).height());
            });

            var largestTitleNumbers = Math.max.apply(Math, titles_numbers)

            $('.feature-block h4').css('height', largestTitleNumbers);

			$('.feature-block').each(function(){
				numbers.push($(this).height());
			});

			var largestNumber = Math.max.apply(Math, numbers);

			$('.feature-block').css('height', largestNumber);
		}, 100);

		$scope.scroll_to = (anchor, seconds)=> {
			var section 	= $('#'+ anchor),
				position 	= section.offset().top,
				exclude		= ['body', 'features', 'pricing', 'payment'],
				anim_anchor	= ['payment', 'body'],
				speed 		= (seconds === undefined) ? 1000 : seconds;

			//$('#landingSideMenu').offcanvas('hide');

			if (anim_anchor.indexOf(anchor) != -1) {
				$('html, body').animate({
					scrollTop	: position - 70
				}, speed, ()=>{
					if (exclude.indexOf(anchor) == -1) {
						$scope.$apply(()=>{
							$scope.features_btn_active = true;
						});
					}
				});
			} else {
				window.scrollTo(0, position - 70);

				if (exclude.indexOf(anchor) == -1) {
					$scope.features_btn_active = true;
				}
			}
		};

		$timeout(function(){
			$scope.fadeOutInHeroIntro();
		}, 5000);

		$('.popup-video').magnificPopup({
		  disableOn: 700,
		  type: 'iframe',
		  mainClass: 'mfp-fade',
		  removalDelay: 160,
		  preloader: false,

		  fixedContentPos: true
		});

		$scope.fadeOutInHeroIntro = () =>{
			var intro_hero 	= $('#intro-hero'),
				hero 		= [{
					bg_image : 'bg-image-1',
					title 	 : content['banner-image-1-title'],
					tagline  : content['banner-image-1-description']
				}, {
					bg_image : 'bg-image-2',
					title 	 : content['banner-image-2-title'],
					tagline  : content['banner-image-2-description']
				}];


			if (intro_hero.attr('class').indexOf('bg-image-2') != -1) {
				var hero_0 = hero[0],
					hero_1 = hero[1];

				hero[0] = hero_1;
				hero[1] = hero_0;
			}

			intro_hero.animate({
				opacity: 0
			}, 500, function(){
				intro_hero.removeClass(hero[0].bg_image);
				intro_hero.addClass(hero[1].bg_image);

				intro_hero.find('h1.hero-title').html(hero[1].title);
				intro_hero.find('p.hero-tagline').html(hero[1].tagline);

				intro_hero.animate({
					opacity: 1
				}, 500, function(){
					$timeout(function(){
						$scope.fadeOutInHeroIntro();
					}, 10000);
				});
			});
		};

		$scope.fadeInHeroText = () =>{
			var heroText = $('.hero-text');

			heroText.animate({
				opacity: 1
			}, 500);
		};

		$scope.start_payment = (type)=> {
			var step = $scope.payment.curr_step;

			this.payment = new Payment($scope.pricings.prices[type.toLowerCase()], $scope.price_type, content, $sce, window.stripe);

			$scope.payment.steps = this.payment.get_steps(step);

			$scope.payment.publish_key = this.payment.publish_key;
			
			for (var i = 1; i <= $scope.payment.steps.length; i++) {
				var form = this.payment.get_form(i);

				if ($scope.payment.form[i] === undefined) {
					$scope.payment.form[i] = {};
				}

				$scope.payment.form[i].html = $sce.trustAsHtml(form.html);
				$scope.payment.form[i].fields = form.fields;
				$scope.payment.form[i].title = $sce.trustAsHtml(form.title);
				$scope.payment.form[i].submit = form.submit;
				$scope.payment.form[i].submit_pay = form.submit_pay;
				$scope.payment.form[i].onsubmit = form.onsubmit;
			}

			$scope.payment.active = true;

			//Payment page opens up underneath "Our Plan" section and scrolls to it
			$scope.scroll_to('payment', 300);

			$('body').on('click', '.form_payment #radioBtn a', function(){
				var sel = $(this).data('title'),
					tog = $(this).data('toggle');

				$('#'+tog).prop('value', sel);

				$('a[data-toggle="'+tog+'"]').not('[data-title="'+sel+'"]').removeClass('active').addClass('notActive');
				$('a[data-toggle="'+tog+'"][data-title="'+sel+'"]').removeClass('notActive').addClass('active');
			});
		};

		$scope.onSubmitForm = (form, fields, step)=> {
			var that 		= this,
				cont 		= true,
				step 		= this.payment.get_steps(step, true),
				post_data	= {process: step.alias};
						
			return new Promise((resolve, reject)=> {
				$scope.continue_payment_btn = true;
				
				if ($scope.payment.curr_step < 3) {
					$(form).find('input').each(function(){
						var name 	= $(this).attr('name'),
							value 	= $(this).val(),
							field 	= {};
						
						$(this).popover('dispose');
						
						if (cont) {
							for (var i in fields) {
								if (name == fields[i].name) {
									field = fields[i];
									
									post_data[fields[i].name] = value;
								}
							}
							
							var validate = that.payment.validate(field, value);

							if (validate !== true) {
								cont = false;
								
								$(this).popover({content : validate});
								$(this).popover('show');
							}
						}
					});
					
					if (!cont) {
						$timeout(function () {
							$scope.continue_payment_btn = false;
						}, 100);
						
						console.log('A problem has occurred');
					} else {
						that.payment.process_payment_form(post_data).then((value)=> {
							$timeout(function () {
								$scope.continue_payment_btn = false;
							}, 100);
							
							if (value.success !== undefined) {
								if (!value.success) {
									for (var i in value.content) {
										var inputField = $(form).find('input[name='+ value.content[i].type +']');
										
										inputField.popover({content : value.content[i].message});
										inputField.popover('show');
									}
								} else {
									resolve(true);
								}
							}
						});
					}
				} else {
					resolve(true);
				}
			});
		};

		$scope.payment_steps_next = ($event, $pay)=> {
			var step 	= $scope.payment.curr_step,
				form 	= $($event.currentTarget).parents('form'),
				fields 	= $scope.payment.form[step].fields,
				values 	= [];

			$scope.onSubmitForm(form, fields, step).then((value)=>{
				if (value === true) {
					for (var i in fields) {
						values.push({
							label 	: fields[i].label.replace('*', ''),
							name	: fields[i].name,
							value	: form.find('input[name="'+ fields[i].name +'"]').val()
						});
					}

					this.payment.save_details(values, step);

					if ($scope.payment.steps[$scope.payment.curr_step].position == 'last') {
						var confirm_details = this.payment.confirm_details();

						$scope.payment.form[step + 1].html = $sce.trustAsHtml(confirm_details.html);
						$scope.payment.form[step + 1].title = confirm_details.title;
						$scope.payment.form[step + 1].submit = confirm_details.submit;
					}

					var payment = this.payment;

					if ($pay !== true) {
						$scope.payment.curr_step += 1;
						$scope.payment.steps = this.payment.get_steps($scope.payment.curr_step);
					} else {
						payment.formOnSubmit().then((value)=>{
							//Make payment
							payment.makePayment(value).then((value)=>{
								if (value.success === true) {
									$scope.payment.curr_step += 1;
									$scope.payment.steps = this.payment.get_steps($scope.payment.curr_step);
								}
							});
						});
					}

					if ($scope.payment.curr_step == 3) {
						if (!payment.stripeActive) {
							$timeout(function () {
								var stripe 			= Stripe(payment.publish_key),
									paymentRequest 	= stripe.paymentRequest({
										country 	: 'IT',
										currency 	: 'eur',
										total		: {
											label 	: 'Demo Total',
											amount	: 1000
										}
									}),
									paymentDetails 	= {
										country 	: 'IT',
										currency 	: 'eur',
										total		: {}
									};
								
								payment.setup_payment_details(stripe, paymentRequest, paymentDetails);
							}, 100);
						}
					}
				}
			});
		};

		$scope.payment_steps_back = ()=> {
			$scope.payment.curr_step -= 1;
			$scope.payment.steps = this.payment.get_steps($scope.payment.curr_step);
		};

		$scope.togglePlan = (type)=> {
			var toggleSwitch 	= $('div.toggle-switch'),
				btnMonthly		= toggleSwitch.find('button.monthly'),
				btnAnnually		= toggleSwitch.find('button.annually'),
				btns 			= toggleSwitch.find('button'),
				selector 		= toggleSwitch.find('div.selector'),
				toggleWidth 	= parseInt(toggleSwitch.width()),
				btn 			= btnMonthly,
				position 		= 1;

			if (type == 'annually') {
				btn = btnAnnually;
				position = selector.width() + 4;
			}

			btns.css('color', '#000');
			btn.css('color', '#FFF');

			selector.animate({
				left: position
			}, 100, function(){
				$scope.$apply(function(){
					$scope.price_type = type;
				});
			});
		};
	}
}
